/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sources_0_LabelInputs */

const en_gc_search_guides_what_is_gridcraft_sources_0_label = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sources_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft v0.7.0: official project documentation`)
};

const zh_gc_search_guides_what_is_gridcraft_sources_0_label = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sources_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft v0.7.0：官方项目文档`)
};

/**
* | output |
* | --- |
* | "GridCraft v0.7.0: official project documentation" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sources_0_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sources_0_label = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sources_0_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sources_0_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sources_0_label(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sources_0_label(inputs)
});
export { gc_search_guides_what_is_gridcraft_sources_0_label as "gc.search_guides.what_is_gridcraft.sources.0.label" }